import ErrorModal from "../../../layout/ErrorModal/ErrorModal";
import styles from "./submitResultModal.module.css";

const SuccessIcon = () => (
  <svg className={styles.icon} viewBox="0 0 200 160" aria-hidden="true">
    <circle cx="100" cy="80" r="70" fill="rgba(255,255,255,0.06)" />
    <circle cx="100" cy="80" r="34" fill="var(--success)" />
    <path d="M84,81 L95,92 L118,66" stroke="#ffffff" strokeWidth="7" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const FailedIcon = () => (
  <svg className={styles.icon} viewBox="0 0 200 160" aria-hidden="true">
    <circle cx="100" cy="80" r="70" fill="rgba(255,255,255,0.06)" />
    <circle cx="100" cy="80" r="34" fill="var(--danger)" />
    <path d="M87,67 L113,93" stroke="#ffffff" strokeWidth="7" fill="none" strokeLinecap="round" />
    <path d="M113,67 L87,93" stroke="#ffffff" strokeWidth="7" fill="none" strokeLinecap="round" />
  </svg>
);

/**
 * Shared success/failed modal shell for the end of an onboarding save step.
 * Mirrors the shell of the existing "Locked" onboarding gate (ErrorModal-based),
 * so all three states share one visual system.
 */
const SubmitResultModal = ({ variant, isModalOpen, setModalOpen, onPrimary, onSecondary, primaryLabel, primaryLoading }) => {
  const isSuccess = variant === "success";

  return (
    <ErrorModal isModalOpen={isModalOpen} setModalOpen={setModalOpen}>
      <div
        className={styles.gate}
        role={isSuccess ? "dialog" : "alertdialog"}
        aria-live={isSuccess ? "polite" : "assertive"}
        aria-labelledby="submit-result-title"
      >
        {isSuccess ? <SuccessIcon /> : <FailedIcon />}
        <p id="submit-result-title" className={styles.title}>
          {isSuccess ? "Saved" : "We couldn't save your salary expectations"}
        </p>
        <p className={styles.desc}>
          {isSuccess
            ? "Your salary expectations have been saved. Next, let's review your full profile."
            : "Your earlier answers have been saved as a draft — check your connection and try again. If this keeps happening, our support team can help."}
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.cta} onClick={onPrimary} disabled={primaryLoading}>
            {primaryLabel || (isSuccess ? "Continue to Review" : primaryLoading ? "Retrying…" : "Try Again")}
          </button>
          {!isSuccess && (
            <button type="button" className={styles.link} onClick={onSecondary}>
              Contact Support
            </button>
          )}
        </div>
      </div>
    </ErrorModal>
  );
};

export default SubmitResultModal;
